export default {
  '_b._qhyy': 'Chuyển đổi ngôn ngữ',

  '_a._jzz': 'Đang tải...',
  '_a._jzgd': 'Tải thêm',
  '_a._wct': 'Chào mừng đến với',
  '_a._gd': 'Thêm',
  '_a._bf': 'Phát',
  '_a._bcz': 'Đang lưu...',
  '_a._sctp': 'Tải ảnh lên',

  '_dl._qssyx': 'Vui lòng nhập email',
  '_dl._qssmm': 'Vui lòng nhập mật khẩu',
  '_dl._ann': 'Đăng nhập',
  '_dl._hmyzh': 'Chưa có tài khoản?',
  '_dl._qzc': 'Đăng ký',
  '_dl._yzhl': 'Đã có tài khoản?',
  '_dl._qdl': 'Đăng nhập',
  '_dl._srqrmm': 'Vui lòng xác nhận mật khẩu',
  '_dl._sryqm': 'Vui lòng nhập mã mời',
  '_dl._sryzm': 'Vui lòng nhập mã xác minh',
  '_dl._ljzc': 'Đăng ký ngay',
  '_dl._zcbsty': 'Việc đăng ký có nghĩa là bạn đã đọc và đồng ý với',
  '_dl._yszc': 'Chính sách Quyền riêng tư',
  '_dl._lcmmbyy': 'Mật khẩu không khớp',

  '_yzm._fsyzm': 'Gửi mã xác minh',
  '_yzm._cxfs': '({time}) Gửi lại',
  '_yzm._fsz': 'Đang gửi...',
  '_yzm._fscg': 'Gửi thành công',

  '_h._zrm': 'Phổ biến nhất',
  '_h._zxd': 'Mới nhất',
  '_h._phb': 'Xếp hạng',
  '_h._qz': 'Hình nền',
  '_h._ssww': 'Tìm kiếm',
  '_h._lsjl': 'Lịch sử',
  '_h._gd': 'Thêm',
  '_h._dl': 'Đăng nhập',
  '_h._ye': 'Số dư',
  '_h._dj': 'Đã đóng băng',
  '_h._ybp': 'Bảng điều khiển',
  '_h._wdqb': 'Ví của tôi',
  '_h._scjl': 'Yêu thích',
  '_h._xxzx': 'Trung tâm tin nhắn',
  '_h._fxhy': 'Chia sẻ với bạn bè',
  '_h._bzzx': 'Trung tâm trợ giúp',
  '_h._ggtf': 'Đặt quảng cáo',
  '_h._bqtz': 'Đầu tư bản quyền',
  '_h._sz': 'Cài đặt',

  '_sy._jx': 'Nổi bật',
  '_sy._xpfb': 'Phát hành mới',
  '_sy._gdsp': 'Thêm video',

  '_qz._jbqz': 'Bộ sưu tập hình nền tinh tế',
  '_qz._ssqz': 'Tìm kiếm hình nền',
  '_qz._qb': 'Tất cả',
  '_qz._zrfg': 'Phong cảnh thiên nhiên',
  '_qz._cxys': 'Nghệ thuật trừu tượng',
  '_qz._csjz': 'Kiến trúc đô thị',
  '_qz._dmyx': 'Anime & Trò chơi',
  '_qz._yzxk': 'Vũ trụ & Ngôi sao',
  '_qz._yl': 'Xem trước',
  '_qz._xzqz': 'Tải xuống hình nền',
  '_qz._fbl': 'Độ phân giải',
  '_qz._fl': 'Danh mục',
  '_qz._jzz': 'Đang tải',
  '_qz._myzdpp': 'Không tìm thấy hình nền phù hợp',

  '_sp._xyjscl': 'Yêu cầu mở khóa để xem',
  '_sp._cz': 'Nạp tiền',
  '_sp._jsqj': 'Mở khóa tất cả tập',
  '_sp._jsbj': 'Mở khóa tập này',
  '_sp._sc': 'Yêu thích',
  '_sp._fx': 'Chia sẻ',
  '_sp._jsqjjs': 'Xác nhận thanh toán {a} để mở khóa tất cả tập?',
  '_sp._jsbjjs': 'Xác nhận thanh toán {a} để mở khóa tập này?',
  '_sp._zfz': 'Đang xử lý thanh toán...',
  '_sp._qrzf': 'Xác nhận thanh toán',
  '_sp._qx': 'Hủy',

  '_qz._smrc': 'Bình minh núi',
  '_qz._cxjh': 'Hình học trừu tượng',
  '_qz._dsyj': 'Cảnh đêm đô thị',
  '_qz._dmfj': 'Phong cảnh anime',
  '_qz._hhxk': 'Bầu trời sao rộng lớn',
  '_qz._slmw': 'Sương mù rừng',
  '_qz._scld': 'Dòng chảy màu sắc',
  '_qz._xdjz': 'Kiến trúc hiện đại',

  '_qb._cbjl': 'Lịch sử nạp tiền',
  '_qb._jyjl': 'Lịch sử giao dịch',
  '_qb._bddz': 'Địa chỉ đã liên kết',
  '_qb._txjl': 'Lịch sử rút tiền',

  '_m._tcdl': 'Đăng xuất',
  '_m._cb': 'Nạp tiền',
  '_m._tb': 'Rút tiền',

  '_cb._ssdz': 'Tìm kiếm tiền tệ hoặc địa chỉ',
  '_cb._bz': 'Tiền tệ',
  '_cb._je': 'Số tiền',
  '_cb._dz': 'Địa chỉ',
  '_cb._sj': 'Thời gian',
  '_cb._cz': 'Thao tác',
  '_cb._zwjl': 'Chưa có giao dịch nào',
  '_cb._dny': 'Trang {a} / {b}',
  '_cb._jyxq': 'Chi tiết giao dịch',
  '_cb._jydz': 'Địa chỉ giao dịch',
  '_cb._zt': 'Trạng thái',
  '_cb._yqr': 'Đã xác nhận',
  '_cb._qb': 'Tất cả',
  '_cb._jt': 'Hôm nay',
  '_cb._j7t': '7 ngày qua',
  '_cb._j30t': '30 ngày qua',
  '_cb._zw': 'Không có',
  '_cb._fzcg': 'Đã sao chép địa chỉ vào clipboard',

  '_jyjl._ssdz': 'Tìm kiếm tiền tệ hoặc địa chỉ',
  '_jyjl._lx': 'Loại',
  '_jyjl._je': 'Số tiền',
  '_jyjl._ye': 'Số dư',
  '_jyjl._dj': 'Đã đóng băng',
  '_jyjl._sj': 'Thời gian',
  '_jyjl._cz': 'Thao tác',
  '_jyjl._zwjyjl': 'Chưa có giao dịch nào',
  '_jyjl._czsx': 'Đặt lại bộ lọc',
  '_jyjl._dny': 'Trang {a} / {b}',
  '_jyjl._jyxq': 'Chi tiết giao dịch',
  '_jyjl._jylx': 'Loại giao dịch',
  '_jyjl._jyje': 'Số tiền giao dịch',
  '_jyjl._jyhye': 'Số dư sau giao dịch',
  '_jyjl._djye': 'Số tiền đã đóng băng',
  '_jyjl._jysj': 'Thời gian giao dịch',
  '_jyjl._jyzt': 'Trạng thái giao dịch',
  '_jyjl._ywc': 'Đã hoàn thành',
  '_jyjl._qb': 'Tất cả',
  '_jyjl._jt': 'Hôm nay',
  '_jyjl._j7t': '7 ngày qua',
  '_jyjl._j30t': '30 ngày qua',

  '_jyjl._tp1': 'Nạp tiền',
  '_jyjl._tp2': 'Rút tiền',
  '_jyjl._tp3': 'Thanh toán',
  '_jyjl._tp4': 'Nạp tiền',
  '_jyjl._tp5': 'Đóng băng',
  '_jyjl._tp6': 'Thu nhập',
  '_jyjl._tp7': 'Thưởng mời',
  '_jyjl._tp8': 'Thưởng đăng nhập',
  '_jyjl._tp9': 'Thu nhập quảng cáo',
  '_jyjl._tp10': 'Thưởng xem video',
  '_jyjl._tp11': 'Thưởng đăng ký',
  '_jyjl._tp12': 'Yêu cầu rút tiền bị từ chối',
  '_jyjl._tp13': 'Thư gửi lì xì',

  '_jyjl._tp14': 'Chuyển khoản nội bộ',

  '_cb._shz': 'Đang xem xét',
  '_cb._yyg': 'Đã phê duyệt',
  '_cb._ybh': 'Đã từ chối',

  '_bddz._tjdz': 'Thêm địa chỉ',
  '_bddz._ssdz': 'Tìm kiếm địa chỉ',
  '_bddz._bz': 'Tiền tệ',
  '_bddz._dz': 'Địa chỉ',
  '_bddz._sysj': 'Lần sử dụng cuối',
  '_bddz._cz': 'Thao tác',
  '_bddz._zwjl': 'Chưa có địa chỉ nào',
  '_bddz._dny': 'Trang {a} / {b}',
  '_bddz._dzewm': 'Mã QR địa chỉ',
  '_bddz._fzdz': 'Sao chép địa chỉ',
  '_bddz._dzxq': 'Chi tiết địa chỉ',
  '_bddz._wl': 'Mạng',
  '_bddz._tjsj': 'Thời gian thêm',
  '_bddz._bzwa': 'Ghi chú',
  '_bddz._ntq': '{a} ngày trước',
  '_bddz._nxsq': '{a} giờ trước',
  '_bddz._nfzq': '{a} phút trước',
  '_bddz._ngg': 'Vừa xong',
  '_bddz._dzyfz': 'Đã sao chép địa chỉ vào clipboard',
  '_bddz._scqr': 'Xác nhận xóa',
  '_bddz._scqrdz': 'Bạn có chắc chắn muốn xóa địa chỉ này?',
  '_bddz._qr': 'Xác nhận',
  '_bddz._qx': 'Hủy',
  '_bddz._scdzcg': 'Xóa địa chỉ thành công',

  '_txjl._ztsx': 'Bộ lọc trạng thái',
  '_txjl._qbzt': 'Tất cả trạng thái',
  '_txjl._shz': 'Đang xem xét',
  '_txjl._ytg': 'Đã phê duyệt',
  '_txjl._yjj': 'Đã từ chối',
  '_txjl._ssdz': 'Tìm kiếm địa chỉ hoặc số tiền',
  '_txjl._bz': 'Tiền tệ',
  '_txjl._je': 'Số tiền',
  '_txjl._dz': 'Địa chỉ',
  '_txjl._zt': 'Trạng thái',
  '_txjl._sj': 'Thời gian',
  '_txjl._cz': 'Thao tác',
  '_txjl._zwjl': 'Chưa có giao dịch nào',
  '_txjl._czsx': 'Đặt lại bộ lọc',
  '_txjl._dny': 'Trang {a} / {b}',
  '_txjl._jyxq': 'Chi tiết giao dịch',
  '_txjl._skdz': 'Địa chỉ nhận',
  '_txjl._jysj': 'Thời gian giao dịch',
  '_txjl._jyzt': 'Trạng thái giao dịch',
  '_txjl._fzdz': 'Đã sao chép địa chỉ vào clipboard',

  '_cbsq._bz': 'Tiền tệ',
  '_cbsq._wl': 'Mạng',
  '_cbsq._erwm': 'Mã QR',
  '_cbsq._fzdz': 'Sao chép địa chỉ',

  '_txsq._bz': 'Tiền tệ',
  '_txsq._wl': 'Mạng',
  '_txsq._ye': 'Số dư',
  '_txsq._sxf': 'Phí',
  '_txsq._zxtx': 'Rút tối thiểu',
  '_txsq._txdz': 'Địa chỉ rút tiền',
  '_txsq._qxztxdz': 'Vui lòng chọn địa chỉ rút tiền',
  '_txsq._txje': 'Số tiền rút',
  '_txsq._qsrtxje': 'Vui lòng nhập số tiền rút',
  '_txsq._yxyzm': 'Mã xác minh email',
  '_txsq._qsryxyzm': 'Vui lòng nhập mã xác minh',
  '_txsq._ljtx': 'Rút tiền ngay',

  '_jl._wxhd': 'Yêu thích của tôi',
  '_jl._lsjl': 'Lịch sử',

  '_xx._bt': 'Trung tâm tin nhắn',
  '_xx._wjl': 'Không có bản ghi',
  '_xx._zsmyxx': 'Chưa có tin nhắn nào',
  '_xx._sxxx': 'Làm mới tin nhắn',
  '_xx._sxcg': 'Làm mới thành công',

  '_fx._fxhy': 'Chia sẻ với bạn bè',
  '_fx._smfx': 'Quét mã QR để chia sẻ với bạn bè',
  '_fx._jlsm': 'Mô tả phần thưởng',
  '_fx._jlsm1': '1. Bạn bè mời trực tiếp (Cấp 1) cho bạn {a}% thu nhập của họ.',
  '_fx._jlsm2': '2. Bạn bè được mời bởi bạn bè Cấp 1 (Cấp 2) cho bạn {a}% thu nhập của họ.',
  '_fx._jlsm3': '3. Bạn bè được mời bởi bạn bè Cấp 2 (Cấp 3) cho bạn {a}% thu nhập của họ.',
  '_fx._fzlj': 'Sao chép liên kết',

  '_bzzx._bzzx': 'Trung tâm trợ giúp',
  '_bzzx._rhzczh': 'Cách tạo tài khoản',
  '_bzzx._zclc': 'Quy trình đăng ký',
  '_bzzx._rhzcxyh': 'Làm thế nào để đăng ký tài khoản mới?',
  '_bzzx._rhzcxyh1': 'Nhấp "Đăng ký", nhập email, đặt mật khẩu và hoàn tất xác minh email.',

  '_bzzx._rhcz': 'Làm thế nào để nạp tiền?',
  '_bzzx._rhcz1': 'Quy trình nạp tiền',
  '_bzzx._rhcz2': 'Hướng dẫn nạp tiền chi tiết',
  '_bzzx._rhcz3': 'Nhấp Ví của tôi, Nạp tiền, chọn loại tiền và gửi đến địa chỉ được cung cấp.',

  '_bzzx._rhjsdj': 'Cách mở khóa phim ngắn',
  '_bzzx._rhjsdj2': 'Nhấp để mở khóa tập riêng lẻ.',

  '_bzzx._rhtx': 'Cách rút tiền từ tài khoản',
  '_bzzx._rhtx1': '1. Vào Ví của tôi, Địa chỉ rút tiền, thêm địa chỉ mới.<br>2. Nhấp Rút tiền, chọn loại tiền, nhập số tiền và chờ.',

  '_bzzx._qtwt': 'Câu hỏi khác',
  '_bzzx._qtwt1': 'Làm thế nào để liên hệ hỗ trợ?',
  '_bzzx._qtwt2': 'Liên hệ chúng tôi qua chat trực tuyến, email hoặc điện thoại.',
  '_bzzx._myzdwt': 'Không tìm thấy câu trả lời?',
  '_bzzx._khjybbzn': 'Đội ngũ của chúng tôi sẵn sàng hỗ trợ thêm.',
  '_bzzx._lxkf': 'Liên hệ hỗ trợ',

  '_ggtf._bt1': 'Đặt quảng cáo',
  '_ggtf._splb': 'Danh sách video',
  '_ggtf._wcyd': 'Sự tham gia của tôi',
  '_ggtf._hdbm': 'Mã sự kiện',
  '_ggtf._tian': 'Ngày',
  '_ggtf._kssj': 'Thời gian bắt đầu',
  '_ggtf._jssj': 'Thời gian kết thúc',
  '_ggtf._ddvp': 'Đạt cấp VIP {a}, trung bình {b} lần tham gia',
  '_ggtf._hdzt': 'Trạng thái sự kiện',
  '_ggtf._wks': 'Chưa bắt đầu',
  '_ggtf._ycy': 'Đã tham gia',
  '_ggtf._qg': 'Mua ngay',
  '_ggtf._mygdl': 'Không còn dữ liệu',
  '_ggtf._qgrtd': 'Quá nhiều người mua, vui lòng thử lại',
  '_ggtf._hdxq': 'Chi tiết sự kiện',
  '_ggtf._hdjs': 'Mô tả sự kiện',
  '_ggtf._cyyq': 'Yêu cầu tham gia',
  '_ggtf._zdtz': 'Đầu tư tối thiểu',
  '_ggtf._vpdj': 'Cấp VIP',
  '_ggtf._rjcy': 'Tham gia trung bình',
  '_ggtf._gmje': 'Số tiền mua',
  '_ggtf._qsrgmje': 'Vui lòng nhập số tiền mua',
  '_ggtf._qx': 'Hủy',
  '_ggtf._ljcy': 'Tham gia ngay',
  '_ggtf._ssjymm': 'Nhập mật khẩu giao dịch',
  '_ggtf._qssjymm': 'Vui lòng nhập mật khẩu giao dịch',
  '_ggtf._ji': 'Cấp',
  '_ggtf._ci': 'lần',
  '_ggtf._zdgm': 'Số tiền mua tối thiểu',
  '_ggtf._zggm': 'Số tiền mua tối đa',
  '_ggtf._zfz': 'Đang xử lý thanh toán...',

  '_wdtg._wjl': 'Chưa có lịch sử tham gia',
  '_wdtg._tzje': 'Số tiền đầu tư',
  '_wdtg._zsy': 'Tổng thu nhập',
  '_wdtg._hdts': 'Thời gian sự kiện',
  '_wdtg._cysj': 'Thời gian tham gia',
  '_wdtg._qzf': 'Đến thanh toán',
  '_wdtg._jxz': 'Đang tiến hành',
  '_wdtg._djszje': 'Tổng số tiền đang chờ',
  '_wdtg._gjb': 'Tổng {a} mục',
  '_wdtg._djs': 'Đang chờ xử lý',
  '_wdtg._zrsy': 'Thu nhập hôm qua',
  '_wdtg._dbl': 'Lượt xem theo yêu cầu',
  '_wdtg._bfl': 'Số lượt phát',
  '_wdtg._wdsy': 'Thu nhập của tôi',
  '_wdtg._bqffc': 'Phần chia của chủ bản quyền',
  '_wdtg._mr0djs': 'Thu nhập hôm qua được tính vào 00:00 mỗi ngày',
  '_wdtg._jrsy': 'Thu nhập hôm nay',
  '_wdtg._mygd': 'Không còn dữ liệu',

  '_bqyy._bqyy': 'Đặt lịch hợp tác bản quyền',
  '_bqyy._qrbq': 'Xác nhận đặt lịch hợp tác?',
  '_bqyy._qx': 'Hủy',
  '_bqyy._tjyy': 'Gửi đặt lịch',

  '_bqyy._spsq': 'Yêu cầu hợp tác bản quyền video',
  '_bqyy._spsy': 'Cùng quảng bá video để có thêm lưu lượng và thu nhập!',
  '_bqyy._ljyy': 'Đặt lịch ngay',
  '_bqyy._sphz': 'Hợp tác bản quyền video là gì?',
  '_bqyy._sphzsm': 'Hợp tác mang lại khả năng hiển thị cao hơn cho lợi ích chung.',
  '_bqyy._sqhch': 'Lợi ích hợp tác',
  '_bqyy._llfz': 'Hỗ trợ lưu lượng',
  '_bqyy._llfzsm': 'Tăng khả năng hiển thị và lượt phát.',
  '_bqyy._sytg': 'Thu nhập tăng',
  '_bqyy._sytgsm': 'Hưởng lợi từ doanh thu quảng cáo cao hơn.',
  '_bqyy._yxhz': 'Hợp tác ưu tiên',
  '_bqyy._yxhzsm': 'Tham gia ưu tiên vào sự kiện chính thức.',
  '_bqyy._yytj': 'Điều kiện đặt lịch',
  '_bqyy._sptg': 'Yêu cầu quảng cáo video',
  '_bqyy._sptgsm': 'Tham gia ít nhất 1 chiến dịch quảng cáo video.',
  '_bqyy._yysm': 'Đội ngũ của chúng tôi sẽ liên hệ trong 3 ngày làm việc.',

  '_ybp._wdsy': 'Thu nhập của tôi',
  '_ybp._dqye': 'Số dư hiện tại',
  '_ybp._jr': 'Hôm nay',
  '_ybp._jrzsy': 'Tổng thu nhập hôm nay',
  '_ybp._ljzsy': 'Tổng thu nhập tích lũy',
  '_ybp._tgfh': 'Cổ tức quảng cáo',
  '_ybp._ljsy': 'Thu nhập tích lũy',
  '_ybp._bqsy': 'Thu nhập bản quyền',
  '_ybp._yqfh': 'Cổ tức mời',
  '_ybp._mrsy': 'Thu nhập hàng ngày',
  '_ybp._tgsy': 'Thu nhập quảng cáo',

  '_tjdz._tjxd': 'Thêm địa chỉ mới',
  '_tjdz._xzbz': 'Chọn loại tiền',
  '_tjdz._qbdz': 'Địa chỉ ví',
  '_tjdz._srdz': 'Vui lòng nhập địa chỉ ví',
  '_tjdz._qx': 'Hủy',
  '_tjdz._bc': 'Lưu',

  '_sz._smrz': 'Xác minh danh tính',
  '_sz._rzlx': 'Loại xác minh',
  '_sz._sfzzm': 'Mặt trước CMND',
  '_sz._sfzfm': 'Mặt sau CMND',
  '_sz._zsxm': 'Tên thật',
  '_sz._qsrzsxm': 'Vui lòng nhập tên thật',
  '_sz._sfzhm': 'Số CMND',
  '_sz._qsrsfzhm': 'Vui lòng nhập số CMND',
  '_sz._yyzz': 'Giấy phép kinh doanh',
  '_sz._qymc': 'Tên công ty',
  '_sz._yyzzh': 'Số giấy phép kinh doanh',
  '_sz._qsrqymc': 'Vui lòng nhập tên công ty',
  '_sz._qsryyzzh': 'Vui lòng nhập số giấy phép kinh doanh',
  '_sz._qx': 'Hủy',
  '_sz._tjrz': 'Gửi xác minh',
  '_sz._zt': 'Trạng thái',
  '_sz._gr': 'Cá nhân',
  '_sz._qy': 'Công ty',
  '_sz._shz': 'Đang xem xét',
  '_sz._ytg': 'Đã phê duyệt',
  '_sz._ybh': 'Đã từ chối',

  '_mm._xgmm': 'Đổi mật khẩu',
  '_mm._dqxg': 'Đổi mật khẩu thường xuyên để bảo mật',
  '_mm._dqmm': 'Mật khẩu hiện tại',
  '_mm._xmm': 'Mật khẩu mới',
  '_mm._qrxmm': 'Xác nhận mật khẩu mới',
  '_mm._qx': 'Hủy',
  '_mm._qrxg': 'Xác nhận thay đổi',

  '_jymm._xgjymm': 'Đổi mật khẩu giao dịch',

  '_szzx._sz': 'Cài đặt',
  '_szzx._yrz': 'Đã xác minh',
  '_szzx._wrz': 'Chưa xác minh',
  '_szzx._jymm': 'Mật khẩu giao dịch',
  '_szzx._szjymm': 'Đặt hoặc đổi mật khẩu giao dịch',
  '_szzx._tcdl': 'Đăng xuất',
  '_szzx._qdtcdl': 'Bạn có chắc chắn muốn đăng xuất?',
  '_szzx._qrtc': 'Xác nhận đăng xuất',
  '_szzx._qx': 'Hủy',

  '_yj._gy': 'Giới thiệu',

  '_yj._lxwm': 'Liên hệ với chúng tôi',

  '_yj._yszc': 'Chính sách bảo mật',

  '_yj._yhxy': 'Thỏa thuận người dùng',

  '_cd._gszz': 'Trình độ chuyên môn của công ty',

  '_cd._wmyy': 'Chúng tôi sở hữu đầy đủ các chứng chỉ và bằng cấp chuyên môn trong ngành, cung cấp cho người dùng dịch vụ video hợp pháp, an toàn và chất lượng cao',

  '_cd._yyzz': 'Bằng chứng hợp lệ về hoạt động hợp pháp của công ty, thể hiện thông tin đăng ký chính thức và phạm vi kinh doanh của chúng tôi',

  '_cd._yyzz2': 'Giấy phép kinh doanh được công ty cấp hợp pháp, đảm bảo tính hợp pháp và tuân thủ của nền tảng',

  '_bz._lxkf': 'Nhấp vào bên dưới để liên hệ với bộ phận chăm sóc khách hàng hoặc liên hệ với chúng tôi qua email hoặc đường dây nóng chăm sóc khách hàng',

  '_sz._bjtx': 'Chỉnh sửa',

  '_sz._bjxx': 'Chỉnh sửa tin nhắn',

  '_sz._tx': 'Hình đại diện',

  '_sz._bcun': 'Lưu',

  '_db._zskf': 'Liên hệ Hỗ trợ',
  '_db._zsry': 'Nhân viên hỗ trợ riêng',
  '_db._wdq': 'Chưa đọc',
  '_db._ydq': 'Đã đọc',

  '_sc._sctp': 'Tải ảnh lên',
  '_sc._xztp': 'Chọn ảnh',
  '_sc._fstp': 'Gửi ảnh',
  '_sc._qx': 'Hủy',
  '_sc._hd': 'Đồng ý',

  '_zcyl._zcbt': 'Quà Tặng Đăng Ký',
  '_zcyl._djdkhb': 'Chạm để mở phong bì đỏ',
  '_zcyl._zclj': 'Thưởng Đăng Ký',
  '_zcyl._hmyzh': 'Chưa có tài khoản?',
  '_zcyl._qzc': 'Đăng Ký',
  '_zcyl._qxdjhb': 'Vui lòng nhận thưởng trước',
  '_zcyl._qwzc': 'Đến Trang Đăng Ký',
  '_zcyl._hbysy': 'Phần thưởng đã được sử dụng',

  '_ggtg._qhz': 'Đến Chuyển Khoản',
  '_ggtg._dqye': 'Số Dư Hiện Tại',
  '_ggtg._qcz': 'Đến Nạp Tiền',
  '_ggtg._hzje': 'Số Tiền Chuyển',
  '_ggtg._ljhz': 'Chuyển Ngay',
  '_ggtg._yebz': 'Số Dư Không Đủ',

  '_sq._bhbt': 'Bị từ chối',

  '_sq._bhyy': 'Lý do từ chối',

  '_xx._ntq': '{n} ngày trước',

  '_xx._nxsq': '{n} giờ trước',

  '_xx._nfzq': '{n} phút trước',

  '_xx._nggq': 'Vừa mới đây',

  '_xx._djckgd': 'Nhấp chuột để xem thêm',

  '_ct._zt': 'Trạng thái',

  '_ct._ljz': 'Đang kết nối',

  '_ct._ylj': 'Đã kết nối',

  '_ct._ltlieb': 'Danh sách trò chuyện',

  '_ct._bnhzj': 'Không thể trò chuyện với chính mình',

  '_ct._cylb': 'Danh sách thành viên',

  '_hb._fhb': 'Phong bì đỏ',

  '_hb._dqye': 'Số dư hiện tại',

  '_hb._fsd': 'Đã gửi đến',

  '_hb._hbje': 'Số tiền phong bì đỏ',

  '_hb._qshuru': 'Vui lòng nhập số tiền phong bì đỏ',

  '_hb._ljfs': 'Gửi ngay',

  '_hb._hbz': "Phong bì đỏ' Lời chúc phúc",
  '_hb._qshuruzhu': 'Vui lòng nhập lời chúc phúc của bạn',

  '_sp._cuow': 'Bạn cần mở khóa các tập 1-10 trước khi có thể xem',

  '_bq._tzzq': 'Thời gian đầu tư',

  '_bq._zrsy': 'Lợi nhuận hôm qua',

  '_bq._bqtz': 'Đầu tư bản quyền',

  '_bq._tzdj': 'Số tiền đầu tư',

  '_bq._zfjz': 'Phải thanh toán trong vòng 24 giờ, nếu không sẽ được coi là từ bỏ quyền!',

  '_bq._qzf': 'Thực hiện thanh toán',

  '_bq.jz': 'Hạn chót',

  '_bq._ljzf': 'Thanh toán ngay',

  '_bq._sqbz': 'Ghi chú ứng dụng (Tùy chọn)',

  '_bq._sqbzsm': 'Vui lòng nhập ghi chú ứng dụng',

  '_bq._zzsqz': 'Đơn xin bản quyền đang được xử lý, đang chờ xem xét...',

  '_app._xz': 'Tải xuống ứng dụng ReelShortBiz',

  '_app._smerm': 'Quét mã QR để tải xuống',

  '_app._xzbt': 'Tải xuống',

  '_m._yhzz': 'Chuyển khoản ngân hàng',
  '_m._yhxx': 'Thông tin ngân hàng',
  '_m._yhmz': 'Tên ngân hàng',
  '_m._yhdz': 'Địa chỉ ngân hàng',
  '_m._yhmc': 'Họ tên',
  '_m._yhzh': 'Số tài khoản',
  '_m._yhlx': 'Loại',
  '_m._yhly': 'Định tuyến',
  '_m._yhdm': 'Mã',
  '_m._yhbz': 'Ghi chú',
  '_m._fzxx': 'Sao chép thông tin',

  '_m._zts': 'Mẹo',

  '_m._zyd1': '1. Vui lòng kiểm tra kỹ tên người nhận, số tài khoản và mã ngân hàng khi chuyển tiền. Bất kỳ sai sót nào cũng có thể dẫn đến mất tiền.',

  '_m._zyd2': "2. Nên chọn 'Người gửi chịu mọi phí' để tránh trường hợp thiếu tiền do ngân hàng trung gian khấu trừ.",

  '_m._zyd3': '3. Chuyển tiền thường mất 1-3 ngày làm việc. Vui lòng kiên nhẫn. Nếu có thắc mắc, vui lòng liên hệ bộ phận chăm sóc khách hàng.',

  '_m._zyd4': '4. Nếu có bất kỳ câu hỏi nào khác, vui lòng liên hệ bộ phận chăm sóc khách hàng.',

  '_m._jyh': 'Số giao dịch',

  '_m._jyje': 'Số tiền',

  '_sp._dbye': 'Số dư VOD',
  '_sp.hzye': 'Chuyển khoản',
  '_sp._txje': 'Số tiền chuyển',
  '_sp._qsrtxje': 'Vui lòng nhập số tiền chuyển',
  '_sp._ljhz': 'Chuyển ngay',
  '_sp._yebz': 'Số dư không đủ',
  '_sp._qshuru': 'Vui lòng nhập số tiền chuyển chính xác',
  '_sp._fanh': 'Quay lại',

  '_sp._tliu': 'Chạy Quảng Cáo',
  '_sp._xzgj': 'Chọn Quốc Gia',
  '_sp._cdcw': 'Lỗi Mã Hóa Video',
  '_ggtf._hot': 'Thịnh Hành',
  '_tl._tlsj': 'Thời Gian Chạy',
  '_tl._xzxb': 'Chọn Giới Tính',
  '_tl._nan': 'Nam',
  '_tl._nv': 'Nữ',
  '_tl._hunhe': 'Hỗn Hợp',
  '_tl._xznl': 'Chọn Độ Tuổi',
  '_sp._us': 'Hoa Kỳ',
  '_sp._en': 'Vương Quốc Anh',
  '_sp._jp': 'Nhật Bản',
  '_sp._fr': 'Pháp',
  '_sp._kr': 'Hàn Quốc',
  '_sp._de': 'Đức',
  '_sp._id': 'Ấn Độ',
  '_sp._in': 'Indonesia',
  '_sp._au': 'Úc',
  '_sp._es': 'Tây Ban Nha',
  '_sp._my': 'Malaysia',
  '_sp._cn': 'Trung Quốc',
  '_ggtf._fanhui': 'Quay Lại',
  '_ggtf._jymmts': 'Vui lòng xác nhận số tiền giao dịch và nhập mật khẩu',
  '_wdtg._wjl_desc': 'Bạn chưa tham gia bất kỳ chiến dịch quảng cáo nào',
  '_wd._jxz': 'Đang Tiến Hành',
  '_wd._djs': 'Chờ Thanh Toán',
  '_wd._ywc': 'Đã Hoàn Thành',
  '_wd._jz': 'Khẩn Cấp',
  '_wd._hz': 'Chuyển Khoản',

  '_tl._tlfbqk': 'Phân Bổ Chi Phí Quảng Cáo',
  '_tl._tlfbqk_desc': 'Ngày 1-5: 5% (Giai đoạn khởi động nguội), Ngày 6-10: 20% (Giai đoạn xác thực nội dung), Ngày 11-15: 40% (Giai đoạn xây dựng IP), Ngày 16-20: 35% (Giai đoạn ma trận phim ngắn)',

  '_nhz._sm': 'Sau khi chuyển khoản, số tiền sẽ được chuyển vào ví video để mở khóa nội dung video',
  '_nhz._zhzz': 'Đang chuyển...',
  '_nhz._zzcg': 'Chuyển khoản thành công',
  '_nhz._zhzsb': 'Chuyển khoản thất bại, vui lòng thử lại',
  '_m._fzcg': 'Sao chép thành công',
  '_m._fzsb': 'Sao chép thất bại, vui lòng sao chép thủ công',
  '_m._zwfzxx': 'Không có thông tin để sao chép',
  '_tx._qb': 'Tất cả',
  'activity.detail': 'Chi Tiết Hoạt Động',
  'activity.noDesc': 'Không có mô tả hoạt động',
  'activity.desc': 'Mô Tả Hoạt Động',
  'activity.requirements': 'Yêu Cầu Tham Gia',
  'activity.minInvest': 'Đầu Tư Tối Thiểu',
  'activity.vipLevel': 'Cấp Độ VIP',
  'activity.avgParticipation': 'Tham Gia Trung Bình',
  'activity.avgParticipationDesc': 'lần',
  'activity.country': 'Chọn Quốc Gia',
  'activity.deliveryTime': 'Thời Gian Quảng Cáo',
  'activity.deliveryTimeDesc': 'ngày',
  'activity.gender': 'Chọn Giới Tính',
  'activity.male': 'Nam',
  'activity.female': 'Nữ',
  'activity.mixed': 'Hỗn Hợp',
  'activity.age': 'Chọn Độ Tuổi',
  'activity.amount': 'Số Tiền Mua',
  'activity.back': 'Quay Lại',
  'activity.join': 'Tham Gia Ngay',
  emptyData: 'Không Có Dữ Liệu',
  emptyDataDesc: 'Không có chiến dịch quảng cáo tham gia',
  completedtlement: 'Đã Hết Hạn',
  preheat: 'Đang Làm Nóng',
  progress: 'Đang Tiến Hành',
  settlement: 'Chờ Thanh Toán',
  transfered: 'Đã Chuyển',
  completed: 'Hoàn Thành',
  activityCode: 'Mã Hoạt Động',
  touzAmount: 'Số Tiền Đầu Tư',
  activityDays: 'Ngày Hoạt Động',
  joinTime: 'Thời Gian Tham Gia',
  playSource: 'Phân Phối Nguồn Phát',
  allPlatforms: 'Tất Cả Nền Tảng',
  other: 'Khác',
  totalPlayNum: 'Tổng Lượt Phát',
  incomeSummary: 'Tóm Tắt Thu Nhập',
  totalPay: 'Phí Bản Quyền Đã Thanh Toán',
  totalIncome: 'Tổng Thu Nhập',
  copyrightRatio: 'Tỷ Lệ Chia Sẻ Chủ Sở Hữu',
  promotionIncome: 'Thu Nhập Quảng Bá',
  copyrightIncome: 'Chia Sẻ Bản Quyền',
  playNum: 'Lượt Phát',
  buyNum: 'Lượt Phát Theo Yêu Cầu',
  incomeRate: 'Tỷ Lệ Chia Sẻ',
  yjIncome: 'Thu Nhập Ước Tính',
  paid: 'Đã Thanh Toán',
  timeout: 'Hết Giờ',
  transfer: 'Chuyển Ngay',
  loading: 'Đang Tải...',
  loadMore: 'Tải Thêm',
  noMore: 'Không Còn Nữa',
  nightTime: 'Khung Đêm',
  morningTime: 'Khung Sáng',
  afternoonTime: 'Khung Chiều',
  eveningTime: 'Khung Tối',
  '_h._tc': 'Đăng Xuất',
  periodPayment: 'Thanh Toán Theo Khung Giờ',
  periodPaymentDesc: 'Thanh toán diễn ra 4 lần mỗi ngày trong 4 khung giờ, bạn có thể thanh toán phí bản quyền theo khung giờ',

  day: 'ngày',
  '_dl._hy': 'Chào mừng trở lại',
  '_dl._cj': 'Tạo tài khoản',
  '_dl._zmm': 'Đặt lại mật khẩu',
  '_dl._hyDesc': 'Đăng nhập vào tài khoản của bạn để tiếp tục khám phá nội dung tuyệt vời',
  '_dl._cjDesc': 'Tham gia ReelShortBiz và bắt đầu hành trình thú vị của bạn',
  '_dl._zmmDesc': 'Nhập email của bạn, chúng tôi sẽ gửi mã xác minh để đặt lại',
  '_dl._hlgqsp': 'Kho phim và video HD phong phú',
  '_dl._gxhty': 'Thuật toán đề xuất cá nhân hóa',
  '_dl._ffddsp': 'Video ngắn đa dạng',
  '_dl._dlzh': 'Đăng nhập',
  '_dl._sdndyx': 'Nhập email và mật khẩu của bạn để tiếp tục',
  '_dl._email': 'Địa chỉ email',
  '_dl._qsryx': 'Vui lòng nhập địa chỉ email của bạn',
  '_dl._dlmm': 'Mật khẩu',
  '_dl._qsrmm': 'Vui lòng nhập mật khẩu của bạn',
  '_dl._wjmm': 'Quên mật khẩu?',
  '_dl._immdl': 'Đăng nhập ngay',
  '_dl._hmyzh2': 'Chưa có tài khoản?',
  '_dl._ljzc2': 'Đăng ký ngay',
  '_dl._cjzh': 'Tạo tài khoản',
  '_dl._jswmd': 'Tham gia ReelShortBiz và bắt đầu hành trình thú vị của bạn',
  '_zh._qszmm': 'Vui lòng đặt mật khẩu của bạn',
  '_zh._qrmm': 'Xác nhận mật khẩu',
  '_zh._qmm': 'Vui lòng nhập lại mật khẩu',
  '_zc._yqm': 'Mã mời',
  '_zc._sryqm': 'Vui lòng nhập mã mời',
  '_dl._yzm': 'Mã xác minh',
  '_dl._qsryzm': 'Vui lòng nhập mã xác minh',
  '_dl._yjyzh': 'Đã có tài khoản?',
  '_dl._zcbsty2': 'Bằng cách đăng ký, bạn đồng ý với',
  '_dl._zcbstyDesc': 'Chính sách bảo mật',
  '_dl._newmm': 'Mật khẩu mới',
  '_dl._qszxmm': 'Vui lòng đặt mật khẩu mới',
  '_dl._qrmm': 'Xác nhận mật khẩu',
  '_dl._qzcsrmm': 'Vui lòng nhập lại mật khẩu mới',
  '_dl._czmm': 'Đặt lại mật khẩu',
  '_dl._xqlmm': 'Đã nhớ mật khẩu?',
  '_dl._fhdl': 'Quay lại đăng nhập',
  '_dl._srdllmmbyz': 'Mật khẩu không khớp',
  '_dl._czcg': 'Đặt lại mật khẩu thành công',
  '_h._zc': 'Đăng ký',
  // '_ybp._wdsy': 'Thu nhập của tôi',
  '_ybp._jrsy': 'Thu nhập hôm nay',
  '_ybp._jztr': 'So với hôm qua',
  '_ybp._bfl': 'Lượt xem',
  '_ybp._dbl': 'Yêu cầu',
  '_ybp._syqs': 'Xu hướng thu nhập',
  // '_ybp._jr': 'Hôm nay',
  '_ybp._t': 'ngày',
  // '_ybp._dqye': 'Số dư tài khoản',
  '_ybp._djs': 'Chờ thanh toán',
  '_ybp._zhl': 'Tỷ lệ chuyển đổi',
  '_ybp._sjgl': 'Tổng quan dữ liệu',
  '_ybp._zrsy': 'Thu nhập hôm qua',
  '_ybp._bysy': 'Thu nhập tháng này',
  '_ybp._yysj': 'Dữ liệu vận hành',
  '_ybp._zr': 'Hôm qua',
  '_ybp._zjfrs': 'Tổng người dùng trả phí',
  '_ybp._mtdqje': 'Số tiền đến hạn ngày mai',
  '_ybp._jsy': 'Thu nhập ròng',
  '_ybp._bqfy': 'Kế hoạch thanh toán phí bản quyền',
  '_ybp._yzf': 'Đã thanh toán',
  '_ybp._qzf': 'Đi thanh toán',
  '_ybp._bqfyts': 'Sau khi thanh toán phí bản quyền, thu nhập và quyền lợi của bạn sẽ được ưu tiên',
  '_ybp._syjl': 'Lịch sử thu nhập',
  '_ybp._ckgd': 'Xem thêm',
  '_ybp._ssdt': 'Cập nhật trực tiếp',
  '_ybp._bzzx': 'Trung tâm trợ giúp',
  '_ybp._lxkf': 'Liên hệ hỗ trợ',
  '_ybp._zrxz': 'Thu nhập hôm qua',
  '_ybp._zdsy': 'Tổng thu nhập',
  '_ybp._qygy': 'Tháng trước',
  '_ybp._jsjl': 'Lịch sử thanh toán',
  '_ybp._hzjl': 'Lịch sử chuyển khoản',
  '_ybp._jfzq': 'phút trước',
  '_ybp._fzq': 'giờ trước',
  '_ybp._djs_mt': 'Số tiền thanh toán ngày mai',
  '_yj._rule': 'Quy tắc nền tảng',

  '_bq._jjks': 'Bắt đầu ngay',
  '_bq._jxz': 'Đang diễn ra',
  '_bq._jks': 'Thời gian đến khi bắt đầu',
  '_bq._jjs': 'Thời gian đến khi kết thúc',
  '_bq._t': 'ngày',
  '_bq._h': 'giờ',
  '_bq._m': 'phút',
  '_bq._s': 'giây',
  '_bq._kssj': 'Thời gian bắt đầu',
  '_bq._jssj': 'Thời gian kết thúc',
  '_bqq._tzdj': 'Đơn giá',
  '_bqq._hdts': 'Số ngày sự kiện',
  '_bqq._vip': 'Cấp độ VIP',
  '_bqq._rjcy': 'Tham gia trung bình',
  '_bqq._cs': 'lần',
  '_bqq._ysjd': 'Tiến độ bán hàng',
  '_bqq._ljqg': 'Mua ngay',
  '_bqq._zbkqg': 'Hiện chưa thể mua',
  '_bqq._jzz': 'Đang tải',
  '_bqq._jzgd': 'Tải thêm',
  '_bqq._wz': 'Không còn nữa',

  '_sp._gdsj': 'Tổng {n} tập',
  '_sy._jl': 'Bản ghi thanh toán đang chờ',
  '_ybp._zsy': 'Tổng doanh thu',
  '_ybp._djsjl': 'Bản ghi thanh toán đang chờ',
  '_ybp._bqbm': 'Mã',
  '_ybp._je': 'Số tiền',
  '_ybp._sj': 'Thời gian',
  '_sy._djs': 'Đang chờ',
  '_sy._yjs': 'Đã thanh toán',
  '_sy._gdstjl': 'Tổng {n} bản ghi',
  '_sy._gjd': 'Tổng {n}'
}
